import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

class Progress extends React.Component {
    render() {
        return <CircularProgress color="primary" variant="indeterminate"/>;
    }
}

export default Progress;